const RouteState = { render: () => null };
const meta = (hermesTab) => ({ adminTab: 'Hermes', hermesTab });

export const HERMES_ROUTES = [
  { path: 'hermes', redirect: { name: 'AdminHermesOverview' } },
  { path: 'hermes/overview', name: 'AdminHermesOverview', component: RouteState, meta: meta('overview') },
  { path: 'hermes/runs', name: 'AdminHermesRuns', component: RouteState, meta: meta('runs') },
  { path: 'hermes/runs/:runId(\\d+)', name: 'AdminHermesRun', component: RouteState, meta: meta('runs') },
  { path: 'hermes/templates', name: 'AdminHermesTemplates', component: RouteState, meta: meta('templates') },
  { path: 'hermes/templates/:templateId(new|\\d+)/:section?', name: 'AdminHermesTemplate', component: RouteState, meta: meta('templates') },
  { path: 'hermes/executors', name: 'AdminHermesExecutors', component: RouteState, meta: meta('executors') },
  { path: 'hermes/executors/:executorKey', name: 'AdminHermesExecutor', component: RouteState, meta: meta('executors') },
  { path: 'hermes/approvals', name: 'AdminHermesApprovals', component: RouteState, meta: meta('approvals') },
  { path: 'hermes/schedules', name: 'AdminHermesSchedules', component: RouteState, meta: meta('schedules') },
  { path: 'hermes/schedules/:scheduleId(new|\\d+)', name: 'AdminHermesSchedule', component: RouteState, meta: meta('schedules') },
  { path: 'hermes/tests', name: 'AdminHermesTests', component: RouteState, meta: meta('tests') },
  { path: 'hermes/console', name: 'AdminHermesConsole', component: RouteState, meta: meta('console') },
];
